import { Calendar } from '@src/models/app.types'
import defaultReducers from '@src/models/defaultReducers'
import { endOfWeekMoment, startOfWeekMoment } from '@src/screens/ActionGoals/utils'
import { DATE_FORMAT } from '@src/config/momentFormat'
import { PlanStoreState } from './plan.types'

export const reducers = {
  ...defaultReducers,

  updateCalendarState: (state: PlanStoreState, { payload }: { payload: Calendar }) => ({
    ...state,
    calendar: {
      ...payload,
      startDate: startOfWeekMoment(payload.startDate).format(DATE_FORMAT),
      // always snap to end of week based on start date
      endDate: endOfWeekMoment(payload.startDate).format(DATE_FORMAT),
    },
  }),
}

export default reducers
